import { useRef } from 'react'
// shadcn components
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/@/components/ui/tooltip';
import { Textarea } from 'src/@/components/ui/textarea';
import { Button } from 'src/@/components/ui/button';
import { LoadingButton } from 'src/@/components/ui/loading-button';
// icons
import { Bold, Italic, Strikethrough, Link, List, ListOrdered, Code, Paperclip, SendHorizonal } from 'lucide-react';

// ----------------------------------------------------------------------

function ToolbarButton({ icon: Icon, tooltip, onClick, disabled }) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          type="button"
          onClick={onClick}
          disabled={disabled}
          variant="ghost"
          size="icon"
          className="h-7 w-7 text-[#616061] hover:text-[#1D1C1D] hover:bg-[#F0F0F0] dark:text-[#ABABAD] dark:hover:text-[#D1D2D3] dark:hover:bg-[#383838] rounded transition-colors"
        >
          <Icon className="w-4 h-4" />
        </Button>
      </TooltipTrigger>
      <TooltipContent side="top" className="text-xs">
        <p>{tooltip}</p>
      </TooltipContent>
    </Tooltip>
  );
}

// ----------------------------------------------------------------------

export default function KanbanTaskCommentInput({ texto, onCriar, loading, changeTexto, completado, onFile, onKeyPress }) {
  const fileInputRef = useRef(null);

  const handleAttach = () => {
    fileInputRef.current?.click()
  };

  return (
    <TooltipProvider delayDuration={200}>
      <div className="px-5 pb-4 pt-2">
        <div className={`border rounded-lg transition-colors ${completado ? 'border-[#E0E0E0] dark:border-[#383838] bg-[#F8F8F8] dark:bg-[#1A1D21]' : 'border-[#BBBBBB] dark:border-[#565856] bg-white dark:bg-[#222529] focus-within:border-[#1264A3] dark:focus-within:border-[#1264A3] focus-within:shadow-[0_0_0_1px_#1264A3]'}`}>
          {/* Área de texto */}
          <Textarea
            className="w-full min-h-[44px] max-h-[200px] border-0 focus-visible:ring-0 focus-visible:ring-offset-0 shadow-none resize-none text-[15px] leading-[1.46668] px-3 py-2.5 bg-transparent text-[#1D1C1D] dark:text-[#D1D2D3] placeholder:text-[#616061] dark:placeholder:text-[#ABABAD]"
            disabled={!!completado}
            value={texto}
            onChange={changeTexto}
            onKeyPress={onKeyPress}
            rows={1}
            placeholder={completado ? "Este chamado está finalizado" : "Envie uma mensagem..."}
          />

          {/* Toolbar inferior — estilo Slack */}
          {!completado && (
            <div className="flex items-center justify-between px-1.5 pb-1.5">
              {/* Ferramentas de formatação à esquerda */}
              <div className="flex items-center">
                <div className="flex items-center gap-0.5">
                  <ToolbarButton icon={Bold} tooltip="Negrito" />
                  <ToolbarButton icon={Italic} tooltip="Itálico" />
                  <ToolbarButton icon={Strikethrough} tooltip="Tachado" />
                </div>

                <div className="w-px h-5 bg-[#DDDDDD] dark:bg-[#383838] mx-1" />

                <div className="flex items-center gap-0.5">
                  <ToolbarButton icon={Link} tooltip="Link" />
                  <ToolbarButton icon={List} tooltip="Lista" />
                  <ToolbarButton icon={ListOrdered} tooltip="Lista numerada" />
                </div>

                <div className="w-px h-5 bg-[#DDDDDD] dark:bg-[#383838] mx-1" />

                <div className="flex items-center gap-0.5">
                  <ToolbarButton icon={Code} tooltip="Código" />
                  <ToolbarButton icon={Paperclip} tooltip="Anexar arquivo" onClick={handleAttach} />
                  <input
                    hidden
                    className="file-input"
                    type="file"
                    ref={fileInputRef}
                    multiple={true}
                    onChange={onFile}
                  />
                </div>
              </div>

              {/* Botão de enviar à direita */}
              <LoadingButton
                disabled={!!completado || loading || !texto?.trim()}
                onClick={onCriar}
                loading={loading}
                variant="default"
                size="icon"
                className={`h-7 w-7 rounded transition-colors ${texto?.trim() ? 'bg-[#007A5A] hover:bg-[#148567] text-white shadow-none' : 'bg-white dark:bg-[#383838] text-[#BBBBBB] dark:text-[#616061] border border-[#DDDDDD] dark:border-[#565856] hover:bg-[#F8F8F8] dark:hover:bg-[#444444] shadow-none'}`}
              >
                <SendHorizonal className="w-4 h-4" />
              </LoadingButton>
            </div>
          )}
        </div>
      </div>
    </TooltipProvider>
  );
}
